import lottie, {AnimationItem} from 'lottie-web/build/player/lottie_light';
import {useRef, useEffect, CSSProperties} from 'react';

interface IProps extends React.HTMLProps<HTMLDivElement> {
  animationData: object | string;
  loop?: boolean;
  autoplay?: boolean;
  lottieRef?: React.MutableRefObject<AnimationItem | undefined>;
  onComplete?: () => void;
  style?: Omit<CSSProperties, 'width' | 'height'>;
}

export default function Lottie({
  loop = false,
  autoplay = true,
  animationData,
  lottieRef,
  onComplete,
  style,
  ...rest
}: IProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const innerLottieRef = useRef<AnimationItem>();
  const onCompleteRef = useRef(onComplete);

  useEffect(() => {
    onCompleteRef.current = onComplete;
  });

  useEffect(() => {
    if (containerRef.current) {
      innerLottieRef.current = lottie.loadAnimation({
        container: containerRef.current,
        renderer: 'svg',
        loop,
        autoplay,
        [typeof animationData === 'string' ? 'path' : 'animationData']:
          animationData,
      });
      const complete = onCompleteRef.current;
      if (complete) {
        innerLottieRef.current.addEventListener('complete', complete);
      }
      if (lottieRef) {
        lottieRef.current = innerLottieRef.current;
      }
    }
    return () => innerLottieRef.current && innerLottieRef.current.destroy();
  }, [animationData, autoplay, lottieRef, loop]);

  return (
    <div
      ref={containerRef}
      style={{
        ...style,
      }}
      {...rest}
    />
  );
}
